import "./Instruction.scss";
import { InstructionItem } from "../InstructionItem/InstructionItem";
import { IconSvg } from "../../../../../../../../../../utils/constants/icons/iconSvg.constant";
import { useTranslation } from "../../../../../../../../../../hooks";

export const Instruction = ({ onClose }) => {
  const { cabinet: { orders: { residential: { instruction } } } } = useTranslation();

  return (
    <div className="instruction">
      <div className="instruction__head">
        <div className="instruction__title">{instruction}</div>
        <button
          className="custom__modal__container__close_btn"
          onClick={onClose}
        >
          <IconSvg tag="close" />
        </button>
      </div>
      <ul className="instruction__items">
        <InstructionItem/>
        <InstructionItem/>
        <InstructionItem />
        <InstructionItem />
        <InstructionItem />
        <InstructionItem />
      </ul>
    </div>
  );
};
